import servicesConfig from '../config/services.json';

/**
 * Services principaux FIXES de l'application (structure du catalogue).
 * Source : src/config/services.json — jamais modifiable depuis l'admin.
 */
export const mainServiceGroups = servicesConfig.groups;

// URL dérivée du slug — routes stables (/services/type/:slug)
export const servicePath = (slug) => `/services/type/${slug}`;

export const mainServices = servicesConfig.groups.flatMap((g) =>
  g.services.map((s) => ({ ...s, path: servicePath(s.slug), group: g.id })),
);

export const getMainService = (slug) => mainServices.find((s) => s.slug === slug) || null;

/** Nom localisé : nameAr (ar) / nameEn (en) / name (fr — requis) */
export const serviceName = (service, lang) => {
  if (!service) return '';
  if (lang === 'ar') return service.nameAr || service.name;
  if (lang === 'en') return service.nameEn || service.name;
  return service.name;
};

/** Description localisée : descriptionAr (ar) / descriptionEn (en) / description (fr) */
export const serviceDesc = (service, lang) => {
  if (!service) return '';
  if (lang === 'ar') return service.descriptionAr || service.description || '';
  if (lang === 'en') return service.descriptionEn || service.description || '';
  return service.description || '';
};

/** Nom localisé d'un groupe de services */
export const groupName = (group, lang) => {
  if (!group) return '';
  if (lang === 'ar') return group.nameAr || group.name;
  if (lang === 'en') return group.nameEn || group.name;
  return group.name;
};

export const isMainService = (slug) => mainServices.some((s) => s.slug === slug);

export const mainServicesByGroup = (groupId) =>
  servicesConfig.groups.find((g) => g.id === groupId)?.services || [];
